import { mapActions, mapGetters, mapMutations } from "vuex";
import Banner from "@/modules/promotions/banner/index.vue";
import { directive as onClickaway } from "vue-clickaway";
import article from "@/components/article-item/index.vue";
import product from "@/components/product/index.vue";
import productSlider from "./components/product-mobile/index.vue";
import discountProduct from "@/components/discount-product/index.vue";
import Slider from "@/components/slider/index.vue";
import discountSlider from "./components/discount-product-mobile/index.vue";
import clientsSlider from "@/components/slider-clients/index.vue";
import loader from "@/components/misc/loader.vue";
import Product from "@/modules/promotions/promotion-products/components/promotion-product/index.vue";
import catalogProduct from "@/components/catalog-product/index.vue";
import { dynamicHead } from "../../mixins/dynamic-head";


export default {
    name: "home",
    mixins: [dynamicHead],
    data() {
        return {
            isMobile: false,
            mobileArticlesCategory: this.$t('category'),
            showMobileArticlesCategory: false,
            lastScrollTop: "",
            isMounted: false,
            сurrentArticles: "",
            openArticleTabs: false,
            showAllArticles: false,
        };
    },

    created() {
        // this.fetchArticlesList()
        this.changeCategory('rating');
        this.articlesCategoryList();
        if (!this.listTopProducts) {
            this.fetchPromoList();
        }
        if (!this.mainSlider) {
            this.fetchMainSlider();
        }
        if (!this.bannerList) {
            this.fetchBannerList();
        }
        if (!this.articlesList) {
            this.fetchArticlesList(3).then(() => {
                this.сurrentArticles = this.articlesList;
            });
        }
        if (!this.aboutList) {
            this.fetchAboutList();
        }
        if (!this.discountList) {
            this.fetchDiscountList();
        }
        if (!this.clientsSlider) {
            this.fetchClientsSlider();
        }
        // if( !this.favouriteList.length ){
        //     this.fetchFavouriteList().then(()=>{
        //         console.log(this.favouriteList,'this.favouriteList');
        //     });
        // }
    },
    mounted() {
        this.$nextTick(() => {
            this.getSeoData("home").then(() => {
                this.setPageItem(this.seoData);
            });

            this.onResize();
            window.addEventListener("resize", this.onResize, { passive: true });
            if (this.isMobile) {
                if (!this.mobileList) {
                    this.fetchMobileDiscount();
                }
            }
        });
        this.isMounted = true;
        this.scrollTo();
    },
    computed: {
        ...mapGetters({
            seoData: "setting/seoData",
            mainSlider: "home/mainSlider",
            mainSliderLoading: "home/mainSliderLoading",
            listTopProducts: "topProducts/list",
            listTopProductsLoading: "topProducts/listLoading",
            listTopProductsLength: "topProducts/listLength",
            activeProductCategory: "topProducts/activeCategory",
            listLengthProducts: "topProducts/listLength",
            bannerList: "home/bannerList",
            bannerListLoading: "home/bannerListLoading",
            discountList: "discountProducts/list",
            discountListLoading: "discountProducts/listLoading",
            listLengthDiscount: "discountProducts/listLength",
            clientsSlider: "home/clientsSlider",
            clientsSliderLoading: "home/clientsSliderLoading",
            articlesList: "articles/articlesList",
            articlesListLoading: "articles/articlesListLoading",
            activeArticlesCategory: "articles/activeCategory",
            skipArticles: "articles/skip",
            listLengthArticles: "articles/listLength",
            skip: "discountProducts/skip",
            mobileList: "discountProducts/mobileList",
            mobileListLength: "discountProducts/mobileListLength",
            mobileListLoading: "discountProducts/mobileListLoading",
            aboutList: "about/aboutList",
            aboutListLoading: "about/aboutListLoading",
            getPage: "topProducts/getPage",
            getList: `promotions/getList`,
            getProductsLength: "promotions/getProductsLength",
            productLength: "discountProducts/productLength",
            articlesCategory: "articles/articlesCategoryList",
            currentCategoryArticles: "articles/currentCategoryArticles",
            latestArticlesLength: "articles/latestArticlesLength",
            getCurrentArticlesId: "articles/currentArticlesId",
            getCurrentArticlesLength: "articles/currentArticlesLength",
            currentArticlesLoading: "articles/currentArticlesLoading",
            favouriteList: "favorites/whichList",
        }),
        getTime() {
            for (let i in this.getList) {
                if (this.$route.params.promo === this.getList[i].slug) {
                    return this.getList[i];
                }
            }
        },
        isShowButton() {
            if (this.latestArticlesLength) {
                if (this.skipArticles >= this.latestArticlesLength) {
                    return false;
                } else {
                    return true;
                }
            }
            if (this.latestArticlesLength && this.getCurrentArticlesLength) {
                if (this.skipArticles >= this.getCurrentArticlesLength) {
                    return false;
                } else {
                    return true;
                }
            }
        },
    },
    components: {
        Banner,
        Slider,
        product,
        loader,
        "article-item": article,
        "discount-product": discountProduct,
        "clients-slider": clientsSlider,
        discountSlider,
        productSlider,
        Product,
        catalogProduct
    },
    directives: {
        onClickaway: onClickaway,
    },
    watch: {
        "$route.query"() {
            this.scrollTo();
        },
    },
    methods: {
        ...mapActions({
            fetchMainSlider: `home/GET_MAIN_SLIDER`,
            fetchList: `topProducts/GET_PRODUCTS_LIST`,
            fetchBannerList: `home/GET_BANNER_LIST`,
            fetchDiscountList: `discountProducts/GET_PRODUCTS_LIST`,
            fetchClientsSlider: `home/GET_CLIENTS_SLIDER`,
            fetchArticlesList: `articles/GET_ARTICLES_LIST`,
            fetchMobileDiscount: `discountProducts/GET_MOBILE_PRODUCTS_LIST`,
            fetchAboutList: `about/GET_ABOUT_LIST`,
            fetchPromoList: `promotions/GET_PROMOTIONS_LIST`,
            articlesCategoryList: "articles/GET_ARTICLES_LIST_CATEGORY",
            fetchArticlesCurrentCategory: "articles/GET_ARTICLES_CURRENT_CATEGORY",
            fetchFavouriteList: `favorites/GET_FAVORITES_LIST`,
            getSeoData: "setting/GET_SEO_DATA",
        }),
        ...mapMutations({
            changeProductsCategory: `topProducts/CHANGE_CATEGORY`,
            changeArticlesCategory: `articles/CHANGE_CATEGORY`,
            changeDiscountLimit: `discountProducts/CHANGE_SKIP_MOBILE`,
            changeSkip: "articles/CHANGE_SKIP",
            setCurrentArticlesId: "articles/SET_CURRENT_ARTICLES_ID",
            clearArticlesSkip: "articles/CLEAR_ARTICLES_SKIP",
        }),
        getCurrentCategoryArticles(id) {
            this.clearArticlesSkip();
            this.setCurrentArticlesId(id);
            this.showAllArticles = false;
            this.fetchArticlesCurrentCategory(id).then(() => {
                this.сurrentArticles = this.currentCategoryArticles;
            });
        },
        changeCategory(category) {
            this.changeProductsCategory(category);
            this.fetchList();
        },
        changeCategoryArticles(category) {
            this.changeArticlesCategory(category);
            this.fetchArticlesList().then(() => {
                this.showAllArticles = true;
                this.сurrentArticles = [];
                this.сurrentArticles = this.articlesList;
            });

            this.openArticleTabs = true;
        },
        onResize() {
            this.isMobile = window.innerWidth < 800;
        },
        openCatalog() {
            this.$root.$refs.A.changeShowCatalog();
        },
        changeMobileArticleCategory(category, label) {
            this.changeArticlesCategory(category);
            this.fetchArticlesList();
            this.mobileArticlesCategory = label;
            this.showMobileArticlesCategory = false;
        },
        closeMobileArticlesCategory() {
            this.showMobileArticlesCategory = false;
        },
        loadMoreArticles() {
            if (this.showAllArticles) {
                this.changeSkip();
                this.fetchArticlesList(this.latestArticlesLength).then(() => {
                    this.сurrentArticles = this.articlesList;
                });
            }
            if (!this.showAllArticles) {
                this.changeSkip();
                this.fetchArticlesCurrentCategory(this.getCurrentArticlesId).then(() => {
                    this.сurrentArticles = this.currentCategoryArticles;
                });
            }
        },
        scrollTo() {
            if (this.$route.query.hasOwnProperty("scrollTo") && this.isMounted) {
                this.$smoothScroll({
                    updateHistory: false,
                    offset: -75,
                    scrollTo: document.getElementById(this.$route.query.scrollTo),
                });
            }
        },
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
};
